'use client';

import { Pictogram } from '@tuic/web-compositions/core/Pictogram';

import type { PictogramName } from '@tuic/web-compositions/core/Pictogram';
import type { FC, ReactNode } from 'react';

export type ManifestPreliminaryStatusViewProps = {
  title?: string;
  paragraph?: ReactNode;
  pictogram?: PictogramName;
  /** Optional PIN pill rendered between the paragraph and the action. */
  pinLabel?: string;
  pin?: string;
  /** Pre-rendered action element (button or link). Caller controls behaviour. */
  action?: ReactNode;
};

export const ManifestPreliminaryStatusView: FC<
  ManifestPreliminaryStatusViewProps
> = ({ title, paragraph, pictogram, pinLabel, pin, action }) => (
  <div className="my-16 flex flex-col items-center gap-6 text-center text-marine-high-emphasis">
    {pictogram && <Pictogram name={pictogram} size="md" />}

    {title && <h1 className="headline-lg">{title}</h1>}

    {paragraph && <div className="text-lg">{paragraph}</div>}

    {pin && (
      <div className="flex items-center gap-3 rounded-lg bg-ocean-10 px-6 py-3">
        {pinLabel && <span className="text-lg font-semibold">{pinLabel}</span>}
        <span className="text-lg font-semibold">{pin}</span>
      </div>
    )}

    {action}
  </div>
);
